import { CoinEventHeader } from './components/coin-event-header';
import { CoinEventThresholdList } from './components/coin-event-threshold-list';

export function CoinEventContainer() {
	return (
		<div 
			className="shop-content" 
			data-show="true"
		>
			<CoinEventHeader />
			<CoinEventThresholdList />
		</div>
	);
}